// extracted by mini-css-extract-plugin
module.exports = {"newSizeInput":"NewSizeInput_newSizeInput__1VDAB"};